import React from 'react';
import Facebook from '@material-ui/icons/Facebook';
import YouTube from '@material-ui/icons/YouTube';
import Instagram from '@material-ui/icons/Instagram';
import LinkedIn from '@material-ui/icons/LinkedIn';
import Twitter from '@material-ui/icons/Twitter';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import WebIcon from '@material-ui/icons/Web';

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.footerText,
    fontSize: '3rem',
  },
}));
export default ({ iconName }) => {
  const classes = useStyles();
  switch (iconName) {
    case 'facebook':
      return <Facebook className={classes.icon} />;
    case 'youtube':
      return <YouTube className={classes.icon} />;
    case 'instagram':
      return <Instagram className={classes.icon} />;
    case 'linkedin':
      return <LinkedIn className={classes.icon} />;
    case 'twitter':
      return <Twitter className={classes.icon} />;
    case 'website':
      return <WebIcon className={classes.icon} />;
    default:
      return <Icon>{iconName}</Icon>;
  }
};
